import type { HTMLAttributes } from "react";

type FooterProps = HTMLAttributes<HTMLDivElement>;

export function Footer({ children, ...props }: FooterProps) {
  return (
    <footer className="body-sm tw:md:max-w-3/5" {...props}>
      {children}
    </footer>
  );
}
